// extracted by mini-css-extract-plugin
export default {"title":"imageUploader_title__wa6+i","imageUploader":"imageUploader_imageUploader__Ybxgq","header":"imageUploader_header__GRcCm"};